/**
 * The Storage Fees line on an invoice: a charge per unit held at 2W's shipping locations past
 * the brand's free period, counted on the 1st for the month just ended. Mirrors the invoice PDF
 * and the brand's billing page.
 */

/** Whether the invoice carries a storage charge at all - a count was taken for its month. */
export function hasStorage(invoice) {
  return Boolean(invoice?.storageCountedAt);
}

/** The storage fee as a number, 0 when absent. */
export function storageFeeOf(invoice) {
  return parseFloat(invoice?.storageFee) || 0;
}

/** "2,435 units stored over 6 months × $0.10". */
export function storageHint(invoice) {
  const units = Number(invoice?.storageUnitsCharged) || 0;
  const free = Number(invoice?.storageFreeMonths) || 0;
  const rate = Number(invoice?.storageRate) || 0;
  return `${units.toLocaleString('en-US')} unit${units === 1 ? '' : 's'} stored`
    + (free > 0 ? ` over ${free} month${free === 1 ? '' : 's'}` : '')
    + ` × $${rate.toFixed(4).replace(/0{1,2}$/, '')}`;
}
